<template>
  <div class="register-mobile-component">
    <v-card
      class="elevation-5 py-2">
      <router-link to="/">
      <v-img
        width="95"
        class="mx-auto my-10"
        src="/img/logo.svg">
      </v-img>
      </router-link>
      <v-toolbar
        dense
        height="20"
        flat>
        <span
          class="titleColorDark--text caption"
          v-if="registrationMode">
          {{ registrationContent.title }}
        </span>
        <span
          class="titleColorDark--text caption"
          v-if="!registrationMode">
          {{ activationContent.title1 }} {{ this.phone }} {{ activationContent.title2 }}
        </span>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form
          @submit.prevent="() => false"
          v-if="registrationMode"
          ref="form"
          class="text-left">
          <v-text-field
            v-model="phone"
            :rules="registrationContent.phoneRules"
            outlined
            autofocus
            :placeholder="registrationContent.phoneNumber"
            required>
          </v-text-field>
          <v-btn
            :loading="loginLoading"
            type="submit"
            color="primary"
            block
            large
            tile
            depressed
            :label="registrationContent.label"
            class="mt-8"
            @click="registerValidate">
            {{ registrationContent.btnText }}
          </v-btn>
        </v-form>
        <!--Activation Mode-->
        <v-form
          v-if="!registrationMode"
          @submit.prevent="() => false"
          ref="form"
          class="text-left"
          lazy-validation>
          <!--
            :rules="activationContent.codeRules"
            -->
          <v-text-field
            v-model="code"
            outlined
            autofocus
            :placeholder="activationContent.phoneNumber"
            required>
          </v-text-field>
          <p
            class="successText--text caption-1 x-3 float-right">
            {{ $t("timer_text") }}
            {{ timerCount }}
          </p>
          <v-btn
            :disabled="resendCode"
            :loading="otpLoading"
            type="submit"
            color="primary"
            block
            large
            tile
            depressed
            :label="activationContent.label"
            class="mt-8"
            @click="activationValidate">
            {{ activationContent.btnText }}
          </v-btn>
          <v-btn
            v-if="resendCode"
            type="button"
            color="primary"
            block
            large
            tile
            depressed
            :label="activationContent.label"
            class="mt-4"
            @click="resendRegisterationCode">
            {{ activationContent.resendCode }}
          </v-btn>
        </v-form>
      </v-card-text>
  </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      otpLoading: false,
      loginLoading: false,
      valid: false,
      registrationMode: true,
      phone: '',
      code: '',
      resendCode: false,
      timer: '',
      timerCount: '',
      countdownTimeSMS: null
    }
  },
  props: {
    registrationContent: {
      require: true,
      type: Object
    },
    activationContent: {
      require: true,
      type: Object
    },
    timerValue: {
      require: true,
      type: String
    }
  },
  beforeDestroy () {
    clearTimeout(this.countdownTimeSMS)
  },
  methods: {
    countDownTimer () {
      this.timer = this.timerValue
      this.countDown()
    },
    countDown () {
      const date = new Date(null)
      date.setSeconds(this.timer)
      this.timerCount = date.toISOString().substr(11, 8)
      if (this.timer > 0) {
        clearTimeout(this.countdownTimeSMS)
        this.countdownTimeSMS = setTimeout(() => {
          this.timer -= 1
          this.countDown()
        }, 1000)
      } else if (this.timer === 0) {
        this.resendCode = true
      }
      return this.timerCount
    },
    registerValidate () {
      if (this.$refs.form.validate()) {
        this.loginLoading = true
        this.$store.dispatch('auth/login', {
          username: this.phone.toEnglishDigits()
        }).then((r) => {
          this.registrationMode = false
          this.$refs.form.resetValidation()
          this.$emit('onRegistrationContent')
          this.countDownTimer()
          this.resendCode = false
        }).catch((e) => {
          this.snackbar({ content: this.$t('message.userNotFound'), color: 'error' })
        }).finally(() => {
          this.loginLoading = false
        })
      }
    },
    resendRegisterationCode () {
      this.$refs.form.reset()
      this.countDownTimer()
      this.resendCode = false
    },
    activationValidate () {
      if (this.$refs.form.validate()) {
        this.otpLoading = true
        this.$store.dispatch('auth/sendOtp', {
          username: this.phone.toEnglishDigits(),
          otp: this.code.toEnglishDigits()
        }).then(() => {
          this.$emit('onActivationContent')
          this.$refs.form.resetValidation()
        }).catch((e) => {
          this.snackbar({ content: this.$t('message.otpWrong'), color: 'error' })
        }).finally(() => {
          this.otpLoading = false
        })
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
<style scoped>
@media (max-width: 425px) {
  .register-mobile-component .elevation-5.v-card {
    box-shadow: none !important;
  }
}

.register-mobile-component {
  margin-bottom: 150px;
}

.v-input {
  direction: ltr !important;
}

</style>
